"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const DidDocumentService_1 = __importDefault(require("./DidDocumentService"));
const jsontokens_1 = require("jsontokens");
const base64url_1 = __importDefault(require("base64url"));
const randomBytes_1 = require("../shared/randomBytes");
const _defaultConfig_1 = require("../_defaultConfig");
class JwtService {
    static getDidFromToken(jwt) {
        const jwtObject = JwtService.fromJWT(jwt);
        const issuerKey = jwtObject.payload.iss;
        return DidDocumentService_1.default.keyIdToDid(issuerKey);
    }
    static fromJWT(token) {
        let data;
        try {
            data = jsontokens_1.decodeToken(token);
        }
        catch (error) {
            // NOTE: to add approrpaite error handler (see NEP-336)
            throw new Error('Invalid Token');
        }
        return data;
    }
    encodeObjectToJWT(jwtObject) {
        if (!jwtObject.payload || !jwtObject.header || !jwtObject.signature) {
            throw new Error('The JWT is not complete, header / payload / signature are missing');
        }
        return [
            base64url_1.default(JSON.stringify(jwtObject.header)),
            base64url_1.default(JSON.stringify(jwtObject.payload)),
            jwtObject.signature,
        ].join('.');
    }
    static buildJWTInteractionToken(interactionToken, type, receivedToken) {
        return __awaiter(this, void 0, void 0, function* () {
            const expiration = Date.now() + _defaultConfig_1.DEFAULT_JWT_EXPIRY_MS;
            const jwt = {
                header: {
                    typ: 'JWT',
                    alg: 'ES256K',
                },
                payload: {
                    interactionToken,
                    exp: expiration,
                    typ: type,
                    jti: '',
                    aud: '',
                },
            };
            if (receivedToken) {
                const keyId = receivedToken.payload.iss;
                const did = keyId.substring(0, keyId.indexOf('#'));
                jwt.payload.aud = did;
                jwt.payload.jti = receivedToken.payload.jti;
            }
            else {
                jwt.payload.jti = yield randomBytes_1.randomBytes(8).toString('hex');
            }
            return jwt;
        });
    }
}
exports.default = JwtService;
//# sourceMappingURL=JwtService.js.map